import { Button } from '@mui/material'
import FuturesEvidencePanel from './FuturesEvidencePanel'

interface Props {
  onOpenDialog: () => void
}

export default function FuturesLocalPriceView({ onOpenDialog }: Props) {
  return (
    <FuturesEvidencePanel
      title="Local Price"
      accessLabel="Input Local Price"
      accessTarget="frmFuturesQryLocalPriceAdd"
      description="Local physical price input screen opened by the Access parent header button. The current web navigation also exposes it as a Futures child route."
      actions={['Input Local Price']}
      evidence={[
        'form_frmFuturesQryLocalPriceAdd.txt',
        'form_frmFuturesQryLocalPriceAdd_subForm.txt',
        'query_FuturesQryPhysicalPrice.txt',
        'query_FuturesQryPhysicalPrice2.txt',
      ]}
      notes={[
        'Access disables the header action when SCREEN_ACCESS <> 1.',
        'Do not merge this with direct Local P/Local S query screens.',
      ]}
    >
      <Button variant="contained" size="small" onClick={onOpenDialog} sx={{ alignSelf: 'flex-start', textTransform: 'none' }}>
        Open Input Local Price
      </Button>
    </FuturesEvidencePanel>
  )
}
